import { createContext } from 'react';

const HelpContext = createContext(null);

export default HelpContext;
